import React, { Component } from "react";
import _ from "lodash";

import { gql, graphql, compose } from "react-apollo";
import withLoading from "../../modules/loader/withLoading";
import ShowView from "./ShowView";
import styled from "styled-components";
import withUser from "../authenticate/withUser";
import withAuthen from "../authenticate/withAuthen";
import withLoggedUser from "../authenticate/withLoggedUser";

class _PostPrivate extends React.Component {
  render() {
    return <div>{this.props.children(this.props)}</div>;
  }
}

const POST_QUERY = gql`
  query PostQuery($id: ID!, $sendTo: String, $from: ID) {
    allPosts(
      filter: {
        AND: [
          { id: $id }
          {
            OR: [
              { sendTo: $sendTo }
              { author: { id: $from } }
              { isPrivate: false }
            ]
          }
        ]
      }
    ) {
      id
      isPrivate
      description
      imageId
      author {
        name
        facebookUserId
      }
      sendTo
    }
  }
`;

const withPost = graphql(POST_QUERY, {
  options: ownProps => {
    return {
      variables: {
        id: _.get(ownProps, "params.postId"),
        from: _.get(ownProps, "loggedUserQuery.loggedInUser.id")
      }
    };
  }
});

const PostPrivate = withAuthen(withPost(_PostPrivate));

class ShowContent extends React.Component {
  state = {
    imageId: undefined
  };
  onImageError = () => {
    this.setState({ imageId: null });
  };
  render() {
    const { post } = this.props;
    if (!post) {
      return null;
    }
    return (
      <CardStyle>
        <div className="card">
          {this.state.imageId !== null && (
            <div className="card-image">
              <img src={post.imageId} onError={this.onImageError} />
            </div>
          )}
          <div className="card-content">
            <span className="card-title">
              <strong>FROM</strong> {_.get(post, "author.name")}
            </span>
            <hr />
            <Content>{_.get(post, "description")}</Content>
          </div>
        </div>
      </CardStyle>
    );
  }
}

class ShowPostContainer extends Component {
  state = {};

  componentMount() {}

  render() {
    let post = _.head(_.get(this.props, "data.allPosts"));

    if (!post) {
      return (
        <ShowView>
          <PostPrivate params={this.props.params}>
            {({ data }) => {
              post = _.head(_.get(data, "allPosts"));
              console.log(data);
              if (data.Post) {
                return (
                  <ShowView>
                    <ShowPostLayout>
                      <ShowContent post={post} />
                    </ShowPostLayout>
                  </ShowView>
                );
              } else {
                <ShowPostLayout>
                  <div className="container">
                    <div className="col s12 m6">
                      <div className="card">
                        <div className="card-content">
                          <span className="card-title">Post is Private ! </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ShowPostLayout>;
              }
            }}
          </PostPrivate>
        </ShowView>
      );
    }

    return (
      <ShowView>
        <ShowPostLayout>
          <ShowContent post={post} />
        </ShowPostLayout>
      </ShowView>
    );
  }
}

const ShowPostLayout = styled.div`
  width: 720px;

  .card .card-image img {
    display: block;
    border-radius: 2px 2px 0 0;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    object-fit: contain;
    object-position: center;
    max-height: 450px;
    width: 100%;
  }
`;

const CardStyle = styled.div`
  overflow: scroll;
  height: 100vh;
`;

const Content = styled.p`
  white-space: pre-line;
`;

export default compose(
  withLoggedUser,
  withUser,
  withPost,
  withLoading
)(ShowPostContainer);



// WEBPACK FOOTER //
// ./src/templates/show-post/ShowPostContainer.js